import {
  envIsDev,
  envIsIntegration,
  envIsLocal,
  isServerNamedWorkspacesAvailable,
} from '../config';
import {RampIdType} from '../generated/graphql';
import {useBetaFeatureAccountSelector} from './useBetaFeature';
import {
  useEntityRampFlag,
  useOrgNameRampFlag,
  useOrgRampFlag,
  useUserRampFlag,
} from './useRampFlag';

/*
Docs for ramp feature flags:
https://www.notion.so/wandbai/Ramp-Feature-Flag-Documentation-da56991072df4c8d980cd36804f52ded
*/

export const useRampFlagDisableFuzzySearch = (entityName: string) => {
  return useEntityRampFlag(
    entityName,
    'disable-fuzzy-search',
    RampIdType.EntityName
  );
};

export const useRampFlagNamedWorkspacesAvailable = () => {
  const userFlag = useUserRampFlag(
    'named-workspaces-available-user',
    RampIdType.UserName
  );
  const orgFlag = useOrgRampFlag(
    'named-workspaces-available-org',
    RampIdType.OrgName
  );
  return userFlag || orgFlag || isServerNamedWorkspacesAvailable();
};

export const useRampFlagLargeWorkspaceMode = () => {
  const userFlag = useUserRampFlag(
    'large-workspace-mode-user',
    RampIdType.UserName
  );
  const orgFlag = useOrgRampFlag(
    'large-workspace-mode-org',
    RampIdType.OrgName
  );
  return userFlag || orgFlag;
};

// (elaina): if removing this flag, be sure to replace it with envIsPublicCloud, because we haven't enabled account selector
// in W&B server yet
export const useRampFlagAccountSelector = () => {
  const userFlag = useUserRampFlag('account-selector', RampIdType.UserName);
  const betaFlag = useBetaFeatureAccountSelector();
  if (envIsLocal) {
    return false;
  }
  if (envIsIntegration || envIsDev) {
    return true;
  }
  return userFlag || betaFlag;
};

export const useRampFlagGlobalRegistry = (orgName: string) => {
  const orgGlobalRegistryFlag = useOrgNameRampFlag(
    orgName,
    'global-registry',
    RampIdType.OrgName
  );
  return orgGlobalRegistryFlag ?? false;
};

export const useRampFlagRunSelectorRunsQuery = () => {
  const userFlag = useUserRampFlag(
    'run-selector-runs-query-user',
    RampIdType.UserName
  );
  const orgFlag = useOrgRampFlag(
    'run-selector-runs-query-org',
    RampIdType.OrgName
  );
  return userFlag || orgFlag;
};
